import { render, staticRenderFns } from "./UserInputFlowTemplate.vue?vue&type=template&id=2662fc62&"
import script from "./UserInputFlowTemplate.vue?vue&type=script&lang=js&"
export * from "./UserInputFlowTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports